import { render, staticRenderFns } from "./Home_menu.vue?vue&type=template&id=fd3f530c&scoped=true&"
import script from "./Home_menu.vue?vue&type=script&lang=js&"
export * from "./Home_menu.vue?vue&type=script&lang=js&"
import style0 from "./Home_menu.vue?vue&type=style&index=0&id=fd3f530c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3f530c",
  null
  
)

export default component.exports